// libraries
import { useRef, useState } from 'react';
import styled from 'styled-components';
import { Button, notification, Switch } from 'antd';
import * as Colors from '@ant-design/colors';

// components
import { ImageTool } from '../../../../shared/image-tool';

// utils
import { txt } from '../../../../../locales/i18n';
import * as UserService from '../../../../../services/bb-api/user';

export function UserImageTab(props: any): JSX.Element {
	const [user, setUser] = props.useUser;
	const [imageSource, setImageSource] = useState<string>(user.image);
	const [imageApproved, setImageApproved] = useState<boolean>(Boolean(user.imageApproved));
	const imageToolRef = useRef<any>(null);

	async function handleUpdate(): Promise<void> {
		const canvas: any = imageToolRef.current?.getImage();
		let base64: string | null = null;

		if (canvas !== undefined) {
			base64 = canvas.toDataURL('image/jpeg');

			const imageSize: number = new Blob([String(base64)]).size;
			const maximumImageSize: number = 80_000_000_000;

			if (base64 !== null && imageSize > maximumImageSize) {
				notification.error({ message: txt('notification.image to large') });
				return;
			}
		}

		try {
			await UserService.updateProfileImage(user.id, base64, imageApproved);
			setUser((previous: Record<string, any>) => ({ ...previous, image: base64, imageApproved }));
			notification.success({ message: txt('notification.update successful') });
		} catch (error) {
			console.error(error);
			notification.error({ message: txt('notification.update failed') });
		}
	}

	function handleApprovalChange(approval: boolean): void {
		setImageApproved(approval);
	}

	return (
		<StyledSection>
			<ImageTool refProxy={imageToolRef} imageSource={imageSource} setImageSource={setImageSource} />

			<div className="button-container">
				<Switch
					checked={imageApproved}
					onChange={handleApprovalChange}
					checkedChildren={txt('global.approved')}
					unCheckedChildren={txt('global.not approved')}
				/>
				<Button type="primary" onClick={handleUpdate}>
					{txt('global.update')}
				</Button>
			</div>
		</StyledSection>
	);
}

const StyledSection = styled.section`
	> .button-container {
		display: flex;
		gap: 1rem;
		align-items: center;
	}

	button.ant-switch {
		zoom: 1.4;

		span {
			font-size: 0.65em;
		}

		&.ant-switch-checked {
			background: ${Colors.green.primary};
		}
	}
`;
